// Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react'

// mobx
import { observer } from 'mobx-react'

// fragments
import { fragments } from 'services/get-fragments'

// semantic-ui
import { Container } from 'semantic-ui-react'

export default observer(() => (
  <Container style={{
    margin: 70,
    maxWidth: 400,
    backgroundColor: "white",
    padding: 40,
    borderRadius: 6, boxShadow: "0px 3px 9px rgba(0,0,0,0.17)"
  }}>
    <fragments.GettingStarted.jsx />
  </Container>
))
